module.exports = __webpack_public_path__ + "static/00008.a122eeb3.jpg";